import React, { useState } from "react";
import { FiltersItem, FiltersLayout } from "ComponentsUI/Filters";
import { RangePicker } from "ComponentsUI/Rangepicker";
import { SelectField } from "ComponentsUI/Selectfield";
import CollapseFiltersContainer from "Containers/CollapseFiltersContainer";
import { inject, observer } from "mobx-react";
import SortContainer from "./SortContainer";
import { pipe } from "Utils/functionalUtils";
import FILTER_TYPES from "./FILTER_TYPES";

const FILTERS_COMPONENTS = {
	[FILTER_TYPES.RANGE]: RangePicker,
	[FILTER_TYPES.SELECT]: SelectField,
};

const TariffsFilterContainer = ({ filters, ApplicationModel, onMobileResetButtonClick }) => {
	const {
		text,
		windowSizeModel: { windowSizes },
	} = ApplicationModel;

	const [flat, setFlat] = useState(true);

	const setOrientation = (value) => {
		setFlat(value);
	};
	return (
		<FiltersLayout>
			<CollapseFiltersContainer
				isProviderCard={true}
				resetFiltersHandler={onMobileResetButtonClick}
				showResetButtonAfterFilterApply
				// twoHiddenFilters
			>
				{filters.map((filter, i) => {
					const FilterComponent = FILTERS_COMPONENTS[filter.type];
					return (
						<FiltersItem key={i}>
							<FilterComponent {...filter.props} text={text} windowSizes={windowSizes} />
						</FiltersItem>
					);
				})}
				<SortContainer
					initAgrregationForPopup={(data) => initAggregation(data)}
					flat={flat}
					setOrientation={(value) => setOrientation(value)}
				/>
			</CollapseFiltersContainer>
		</FiltersLayout>
	);
};

export default pipe(observer, inject("ApplicationModel"))(TariffsFilterContainer);
